import { Component } from '@angular/core';
import { TourismEventsComponent } from '@/tourism-events/tourism-events.common';
import { CategoryEvent } from '@/tourism-events/tourism-events.model';

@Component({
	selector: 'app-tourism-events-antenna-bus',
	template: `<app-tourism-events-full [category]="CategoryEvent.ANTENNA_BUS"></app-tourism-events-full>`,
})
export class TourismEventsAntennaBusComponent extends TourismEventsComponent {
	readonly CategoryEvent = CategoryEvent;
}
